'use client';

import React from 'react';

type BadgeVariant = 'active' | 'inactive' | 'pending' | 'approved' | 'rejected' | 'info' | 'purple' | 'gray' | 'warning';

interface StatusBadgeProps {
  text: string;
  variant?: BadgeVariant;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  active: 'hrm-badge-active',
  inactive: 'hrm-badge-inactive',
  pending: 'hrm-badge-pending',
  approved: 'hrm-badge-approved',
  rejected: 'hrm-badge-rejected',
  info: 'hrm-badge-info',
  purple: 'hrm-badge-purple',
  gray: 'hrm-badge-gray',
  warning: 'hrm-badge-pending',
};

const StatusBadge = React.memo(function StatusBadge({ text, variant = 'active', size = 'md', className="" }: StatusBadgeProps) {
  return (
    <span
      className={`hrm-badge ${variantClasses[variant]} ${className} ${
        size === 'sm'
          ? 'text-[10px] px-2 py-0.5'
          : size === 'lg'
            ? 'text-sm px-3 py-1'
            : ''
      }`}
    >
      {text}
    </span>
  );
});

export default StatusBadge;
